import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import CtaButton from '../cta-button';
import './style.css';

const Hero = (props) => (
  <>
    <Row
      className={`hero-container hero-container-${props.layout}`}
      id={!props.id ? 'hero' : props.id}
      style={{
        backgroundImage: `url(${
          props.defaultImage ? props.defaultImage.default : null
        })`,
        backgroundColor: props.backgroundColor
          ? props.backgroundColor
          : '#ffffff',
      }}
    >
      <Col className={`hero-${props.layout}`}>
        {!props.title || (props.title && props.useH2) ? null : (
          <h1>{props.title}</h1>
        )}
        {props.title && props.useH2 ? <h2>{props.title}</h2> : null}
        {!props.subheading ? null : <p>{props.subheading}</p>}
        {!props.stars ? null : (
          <div className='slider-stars'>
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
          </div>
        )}
        {!props.buttonText || !props.buttonText.length ? null : (
          <CtaButton
            onClick={props.handleScrollToElement}
            buttonText={props.buttonText}
            blackButton
            disabled={props.disabled}
          />
        )}
        {props.buttonNote}
      </Col>
    </Row>
  </>
);

export default Hero;
